const SYNC_QUEUE_KEY = "treasurer.syncQueue";
const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "https://api.wekarecords.com" : "http://localhost:5001");
const SYNC_URL = process.env.REACT_APP_SYNC_URL || `${API_URL}/sync`;
const getAuthToken = () => localStorage.getItem("treasurer.authToken");

const readQueue = () => {
  const stored = localStorage.getItem(SYNC_QUEUE_KEY);
  if (!stored) {
    return [];
  }
  try {
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeQueue = (queue) => {
  localStorage.setItem(SYNC_QUEUE_KEY, JSON.stringify(queue));
};

export const enqueueSync = ({ type, payload }) => {
  if (!type) {
    return;
  }
  const queue = readQueue();
  const item = {
    id: `q-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    payload,
    createdAt: new Date().toISOString()
  };
  queue.push(item);
  writeQueue(queue);
};

export const flushSyncQueue = async () => {
  if (!navigator.onLine) {
    return { status: "offline" };
  }
  if (!SYNC_URL) {
    return { status: "skipped", reason: "missing_sync_url" };
  }
  const token = getAuthToken();
  if (!token) {
    return { status: "unauthenticated" };
  }
  const queue = readQueue();
  if (queue.length === 0) {
    return { status: "empty" };
  }
  try {
    const response = await fetch(SYNC_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ items: queue })
    });
    if (!response.ok) {
      return { status: "error", reason: response.status };
    }
    writeQueue([]);
    return { status: "synced", count: queue.length };
  } catch (error) {
    return { status: "error", reason: "network" };
  }
};
